module.exports = __webpack_public_path__ + "img/0-128.e8cc611d.jpg";